import React from 'react';
var decorateActionMenuChildren = function decorateActionMenuChildren(children, handleClose) {
  var childList = null;
  if (children) {
    childList = React.Children.toArray(children).map(function (child, index) {
      if (! /*#__PURE__*/React.isValidElement(child)) {
        return child;
      }

      // Header isn't interactive, and should be disabled automatically
      // if top element is a Header, disable headerDivider automatically
      if (child.props.variant === 'Header') {
        if (index === 0) {
          return /*#__PURE__*/React.cloneElement(child, {
            headerDivider: false,
            disabled: true
          });
        } else {
          return /*#__PURE__*/React.cloneElement(child, {
            disabled: true
          });
        }
      } else {
        return /*#__PURE__*/React.cloneElement(child, {
          handleClose: handleClose
        });
      }
    });
  }
  return childList;
};
export default decorateActionMenuChildren;